import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box, CircularProgress, Divider, Stack, Typography } from '@mui/material';
import { ColorsV2 } from 'app/constants/color';
import { parseAndFormatDate } from 'app/utils';
import NoData from './NoData';

const OverAllCompliance = () => {
  const {
    complianceLoading,
    compliance: { complianceRates = [], policyName, startDate },
  } = useSelector(state => state.compliance.complianceData);
  const sortDataByDate = data => {
    const sortedData = [...data];
    sortedData.sort((a, b) => new Date(b.date) - new Date(a.date));
    return sortedData;
  };
  const sortedComplianceRates = sortDataByDate(complianceRates);

  const { t } = useTranslation('translation', { keyPrefix: 'compliance' });

  return (
    <>
      <Stack
        direction={'column'}
        justifyContent={'space-between'}
        alignItems='flex-start'
        sx={{
          marginBottom: '10px',
          backgroundColor: ColorsV2.primary,
        }}
      >
        <Typography variant='h6' color={ColorsV2.white}>
          {t('overall_compliance')}
        </Typography>
        <Box sx={{ paddingInline: '3px' }}>
          <Typography variant='subtitle2' color={ColorsV2.textInfo}>
            {t('last_updated')} | {parseAndFormatDate(sortedComplianceRates?.[0]?.date)}
          </Typography>
        </Box>
      </Stack>
      <Divider />
      {complianceLoading ? (
        <Box display={'flex'} justifyContent={'center'} alignItems={'center'} minHeight={100}>
          <CircularProgress size='4rem' sx={{ color: ColorsV2.acent }} />
        </Box>
      ) : (
        <>
          <Typography variant='body2' sx={{color: ColorsV2.textInfo, }}>
            {t('description')}: `&quot;{policyName}&quot;` - {parseAndFormatDate(startDate)}
          </Typography>
          <Box
            display={'flex'}
            mt={'0.9em'}
            p={2.5}
            paddingRight={5}
            justifyContent={'center'}
            alignItems={'center'}
          >
            {sortedComplianceRates.length ? (
              <>
                <Typography variant='body1' sx={{color: ColorsV2.white, marginRight: '10px'}}>
                  {sortedComplianceRates?.[0]?.complianceRate.toFixed(2)}%
                </Typography>
                <Box
                  style={{
                    width: `${sortedComplianceRates?.[0]?.complianceRate}%`,
                    background: ColorsV2.acent,
                    height: '3.25em',
                  }}
                />
                <Box
                  style={{
                    width: `${100 - sortedComplianceRates?.[0]?.complianceRate}%`,
                    background: ColorsV2.outline,
                    height: '3.25em',
                  }}
                />
              </>
            ) : (
              <NoData />
            )}
          </Box>
        </>
      )}
    </>
  );
};

export default OverAllCompliance;
